import { render, staticRenderFns } from "./policy-periodical-select.vue?vue&type=template&id=c0748be8"
import script from "./policy-periodical-select.vue?vue&type=script&lang=js"
export * from "./policy-periodical-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports